import type { ReactNode } from 'react';

/**
 * A section's primary action on a phone: the same button as the head's, kept at the bottom of the
 * screen above the tab bar, within reach of the thumb (FR-UX-1, the approved 390 boards). Hidden
 * from 620 px of shell width up, where the head's own button is the one shown — the switch is in
 * shell.css, so exactly one of the two is ever in the accessibility tree.
 */
export function PhonePrimary({
  children,
  className,
}: {
  readonly children: ReactNode;
  readonly className?: string;
}) {
  return (
    <div className={className ? `phone-primary ${className}` : 'phone-primary'}>{children}</div>
  );
}
